import Vue from "vue";
import { transformDate } from "@/constants/pureFunctions";

Vue.filter(
  "fixSum",
  (sum, numbersAfterDot = 2) =>
    typeof sum === "string" ? sum : +sum.toFixed(numbersAfterDot)
);

Vue.filter("formatDate", (date, format = "L") => {
  if (typeof date === "string") {
    date = date.replace(/[-\.]/g, "/");
  }

  return transformDate(date, format);
});



// WEBPACK FOOTER //
// ./src/plugins/globalFilters.js